import { errorMessage } from '../services/apiError';
const isValidEmail = (emailValue: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(emailValue);
};

export const checkEmailEmpty = (email: string, setError: (error: string) => void): boolean => {
  if (!email.trim()) {
    setError('Please enter your email address');

    return false;
  }

  return true;
};

export const checkEmailFormat = (email: string, setError: (error: string) => void): boolean => {
  if (!isValidEmail(email)) {
    setError('Please enter a valid email address');

    return false;
  }

  return true;
};

export const checkPasswordEmpty = (password: string, setError: (error: string) => void): boolean => {
  if (!password.trim()) {
    setError('Please enter your password');

    return false;
  }

  return true;
};

export const extractErrorMessage = (err: unknown): string => {
  return errorMessage(err, 'We couldn’t send the reset email. Check the address and try again.');
};
